import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';
import Table, {Body, Cell, Row} from '@pb/kit-component-table';

import {MCP_CONTRACT_CELL_WIDTH as WIDTH} from '../../constants';


const SKELETON_ROW_COUNT = 3;

const ContractRowSkeleton = () => (
    <div style={{display: 'flex', alignItems: 'flex-start'}}>
        <div style={{width: 32, flexShrink: 0, paddingTop: 6}}>
            <SkeletonItem width={16} height={16}/>
        </div>
        <div style={{flex: 1, minWidth: 0}}>
            <Table>
                <Body>
                    <Row>
                        <Cell width={WIDTH.contract}><SkeletonItem width={100} height={16}/></Cell>
                        <Cell width={WIDTH.startDate}><SkeletonItem width={80} height={16}/></Cell>
                        <Cell width={WIDTH.endDate}><SkeletonItem width={80} height={16}/></Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.credits}}>
                            <SkeletonItem width={50} height={16}/>
                        </Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.overages}}>
                            <SkeletonItem width={50} height={16}/>
                        </Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.remainingCredits}}>
                            <SkeletonItem width={60} height={16}/>
                        </Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.remainingOverages}}>
                            <SkeletonItem width={60} height={16}/>
                        </Cell>
                    </Row>
                </Body>
            </Table>
        </div>
    </div>
);

export const PricingSkeleton = () => (
    <div style={{padding: 24}}>
        <Group direction="v" gap="xls" alignItems="start">
            <Group direction="v" gap="s">
                <Item className="pb-xs">
                    <SkeletonItem width={150} height={22}/>
                </Item>
                {Array.from({length: SKELETON_ROW_COUNT}, (_, i) => (
                    <ContractRowSkeleton key={i}/>
                ))}
                <Group>
                    <SkeletonItem width={160} height={32}/>
                </Group>
            </Group>
        </Group>
    </div>
);
